import type { DisciplineStageLogsStore } from './interfaces'

export const actions = {
  setLoading (this: DisciplineStageLogsStore, payload: DisciplineStageLogsStore['loading']): void {
    this.loading = payload
  },
  setLogs (this: DisciplineStageLogsStore, payload: DisciplineStageLogsStore['logs']): void {
    this.logs = payload
  },
  appendLogs (this: DisciplineStageLogsStore, payload: DisciplineStageLogsStore['logs']): void {
    this.logs = [...this.logs, ...payload]
  },
  setNextCursor (this: DisciplineStageLogsStore, payload: DisciplineStageLogsStore['nextCursor']): void {
    this.nextCursor = payload
  },
  reset (this: DisciplineStageLogsStore): void {
    this.logs = []
    this.nextCursor = null
  },
}
